<script>
    import {parse, addDays, differenceInMinutes, format} from 'date-fns';
    import Segmento from "./Segmento.svelte";

    export let dia;

    let barras = [];

    const horas = [...Array(24).keys(), 0].map(x => `${x}:00`);

    const horaAFecha = hora => {
      let [h, m] = hora.split(':');
      if (h > 24) {
        return addDays(parse(`2020-01-01 ${h - 24}:${m}`, 'yyyy-MM-dd HH:mm', new Date()), 1);
      } else {
        return parse(`2020-01-01 ${hora}`, 'yyyy-MM-dd HH:mm', new Date())
      }
    };

    $: if (dia && dia.horas) {
        barras = [];
        const inicioDelDia = horaAFecha('00:00');

        let entrada = null;
        let salida = null;
        dia.horas.forEach(marcaje => {
            if (marcaje.motivo.tipo === 'Actividad') {
                entrada = entrada || horaAFecha(marcaje.hora);
            } else {
                salida = horaAFecha(marcaje.hora);

                if (entrada) {
                    const duracion = differenceInMinutes(salida, entrada);
                    barras.push({
                        marcaje,
                        entrada: format(entrada, 'HH:mm'),
                        salida: format(salida, 'HH:mm'),
                        inicio: differenceInMinutes(entrada, inicioDelDia) * 100 / 1440,
                        longitud: duracion * 100 / 1440,
                        duracion: duracion
                    });
                }

                entrada = null;
            }
        });

        barras.sort((a, b) => a.inicio > b.inicio ? 1 : -1);
    }
</script>

<style>
    .progreso {
        margin-bottom: var(--padding-global);
    }

    .leyenda {
        font-size: .8em;
        white-space: nowrap;
    }

    .hora {
        position: relative;
        width: 4.1666666667%;
        display: inline-block;
        text-align: center;
    }

    .hora:after {
        content: '';
        display: block;
        width: 1px;
        height: 15px;
        background: var(--verde);
    }

    .hora span {
        position: relative;
        left: -50%;
    }

    .progreso-contenido {
        border: 1px solid var(--verde);
        height: 30px;
        position: relative;
    }

    @media (max-width: 600px) {
        .hora {
            width: 12.5%;
        }

        .hora:nth-child(2n),
        .hora:nth-child(3n) {
            display: none;
        }
    }

    @media (min-width: 601px) and (max-width: 1280px) {
        .hora {
            width: 8.32%
        }

        .hora:nth-child(even) {
            display: none;
        }
    }
</style>

<div class="progreso">
    <div class="leyenda">
        {#each horas as hora}
            <div class="hora">
                <span>{hora}</span>
            </div>
        {/each}
    </div>

    <div class="progreso-contenido">
        {#each barras as barra}
            <Segmento {barra}/>
        {/each}
    </div>
</div>